<div class="mat-h3">
  Mandant & Abschluss
</div>
<ul>
  <li>
    <div class="mat-h4">
      Mandantennummer
    </div>
    <p>
      Mandantennummer aus dem Buchhaltungssystem (z.b. DATEV, FibuNet, Diamant, Micos)
    </p>
  </li>
  <li>
    <div class="mat-h4">
      Letzter Jahresabschluss
    </div>
    <p>
      Das Datum des letzten Jahresabschlusses
    </p>
  </li>
</ul>
